import { api_GET, api_POST, api_PUT } from "./_api";

const tipoNotificacao_api = {
    GetList: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`TipoNotificacao/GetList`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        })
        return promise;
    },
    GetItem: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`TipoNotificacao/GetItem/${id}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        })
        return promise;
    },
    Post: (obj) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`TipoNotificacao`, obj)
                .then(result => resolve(result))
                .catch(result => reject(result));
        })
        return promise;
    },
    Put: (obj) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT(`TipoNotificacao`, obj)
                .then(result => resolve(result))
                .catch(result => reject(result));
        })
        return promise;
    },
}
export default tipoNotificacao_api;